import { NodeType } from 'enums/ProductFlowMapEnums';
import dagre from 'dagre';
import { Edge, Node, Position } from 'reactflow';
import {
  OrganisationMapNodeDimensions,
  TreeDirection,
} from 'enums/organisationMapEnums';

const emptyCallBack = () => ({});

export const getLayoutedElements = (
  nodes: Node[],
  edges: Edge[],
  direction = TreeDirection.HORIZONTAL
) => {
  const dagreGraph = new dagre.graphlib.Graph();
  dagreGraph.setDefaultEdgeLabel(emptyCallBack);
  dagreGraph.setGraph({ rankdir: direction });

  nodes.forEach(node => {
    dagreGraph.setNode(node.id, {
      width: OrganisationMapNodeDimensions.WIDTH,
      height: OrganisationMapNodeDimensions.HEIGHT,
    });
  });

  edges.forEach(edge => {
    dagreGraph.setEdge(edge.source, edge.target);
  });

  dagre.layout(dagreGraph);

  const newNodes = nodes.map(node => {
    const nodeWithPosition = dagreGraph.node(node.id);
    const newNode = {
      ...node,
      targetPosition: Position.Left,
      sourcePosition: Position.Right,
      data: {
        ...node.data,
        hasTarget: node.data.hasTarget,
        hasSource: node.data.hasSource,
      },
      position: {
        x: nodeWithPosition.x - OrganisationMapNodeDimensions.WIDTH / 2,
        y: nodeWithPosition.y - OrganisationMapNodeDimensions.HEIGHT / 2,
      },
      type: NodeType.PRODUCT_FLOW_MAP_NODE,
    };

    return newNode;
  });

  return { nodes: newNodes, edges };
};
